var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivityEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m25.922 14.042-7.92 4.95-7.92-4.95v-1.98l7.92 4.95 7.92-4.95zm0-3.96h-15.84c-1.1 0-1.98.881-1.98 1.98v11.88a1.98 1.98 0 0 0 1.98 1.98h15.84a1.98 1.98 0 0 0 1.98-1.98v-11.88a1.98 1.98 0 0 0-1.98-1.98"
})));
export default SvgActivityEmail;